import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldDictionaryValueFilter = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.dictionary_value_id,
    name: item?.dictionary_value_name,
    code: item?.dictionary_value_code,
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
    dictionaryId: item?.dictionary_id,
    isSignificant: item?.is_significant,
  }
}

export const getDictionaryValueFilterListApi = (dictionary_id) => {
  const config = {
    method: 'get',
    url: `/api/v1/filters/dictionary_value/${dictionary_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldDictionaryValueFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
